module.exports = __webpack_public_path__ + "static/no_notif-3e1f2263779bf882c77c5074bd1b0b9d.svg";